module.exports = __webpack_public_path__ + "static/media/backgroundLogin.c597fbde.jpg";